import { Inject, Injectable } from '@angular/core';
import { TUnifiedLoginAppsEnvironmentVars } from '@monorepo/types';

export const LoginEndPoints = {
  UNIFIED_ID_LOGIN_REDIRECT: 'UNIFIED_ID_LOGIN_REDIRECT',
  FETCH_USER_BY_LOGIN_PROXY: 'FETCH_USER_BY_LOGIN_PROXY',
  INVALIDATE_SECURITY_KEY: 'INVALIDATE_SECURITY_KEY',
};

type TLoginEndPoints = typeof LoginEndPoints;

type TLoginEndPointsTypes = keyof TLoginEndPoints;

@Injectable({ providedIn: 'root' })
export class UnifiedLoginEnvService {
  public auth_service = '/no_auth_service';
  public mode: TUnifiedLoginAppsEnvironmentVars['mode'] = 'dev';

  HOST_DONAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TLoginEndPoints = {
    UNIFIED_ID_LOGIN_REDIRECT: '',
    FETCH_USER_BY_LOGIN_PROXY: '',
    INVALIDATE_SECURITY_KEY: '',
  };

  constructor(@Inject('environment') private environment: TUnifiedLoginAppsEnvironmentVars) {
    if (environment.auth_services) {
      this.auth_service = environment.auth_services;
    }
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DONAIN = environment.service_host;

    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DONAIN;
    // register all vars
    this.registerVars();
  }

  private registerVars() {
    const api = `/api/v1/login/initiate`;
    const loginEndPoint = this.mode === 'dev' ? `${api}?isDev=true&redirectTo=` : `${api}?redirectTo=`;

    this.env_vars.UNIFIED_ID_LOGIN_REDIRECT = this.HOST_DOMAIN_WITH_PROTOCOL + this.auth_service + loginEndPoint;

    this.env_vars.FETCH_USER_BY_LOGIN_PROXY =
      this.HOST_DOMAIN_WITH_PROTOCOL + this.#fetchenvironmentByAppType() + '/api/v1/securityKey/byLoginProxy';

    this.env_vars.INVALIDATE_SECURITY_KEY =
      this.HOST_DOMAIN_WITH_PROTOCOL + this.#fetchenvironmentByAppType() + '/api/v1/securityKey/invalidate';
  }

  public getEnvVar(arg: TLoginEndPointsTypes): string {
    return this.env_vars[arg];
  }

  getEnvironmentConfig(key: keyof TUnifiedLoginAppsEnvironmentVars) {
    return this.environment[key];
  }

  getAppType(): TUnifiedLoginAppsEnvironmentVars['appType'] {
    return this.environment.appType;
  }

  #fetchenvironmentByAppType() {
    switch (this.environment.appType) {
      case 'MM_APP':
      case 'MM_APP_SOLVEI8': {
        return this.environment.machine_maintainance;
      }
      case 'PT_APP':
        return this.environment.plani8;
      default: {
        return this.environment.auth_services;
      }
    }
  }
}
